import { Accordion, Text } from '@tme/toyota-common';
import styles from './FeaturesTreeAccordion.module.scss';
import _ from 'lodash';
import {
	ExtendedCapability,
	FeaturesAndCapabilitiesResponsePayloadServiceCategoryExt,
	FeaturesAndCapabilitiesResponsePayloadServiceCategorySub
} from '../../@types/dataTypes';
import { removeSpecialCharacters } from '../featuresCarouselItem/featuresCarouselItem.helper';
import React from 'react';
import {
	shouldDisplayCategory,
	shouldDisplaySubCategory
} from '../../tools/tools';

type FeaturesTreeAccordionProps = {
	category:
		| FeaturesAndCapabilitiesResponsePayloadServiceCategoryExt
		| FeaturesAndCapabilitiesResponsePayloadServiceCategorySub;
};

type renderExtendedCapabilitiesProps = {
	capabilities: ExtendedCapability | {};
	parentType: string;
};

export default function FeaturesTreeAccordion({
	category
}: FeaturesTreeAccordionProps): React.JSX.Element {
	const hasSubCategory =
		`subCategory` in category && !_.isEmpty(category.subCategory);

	const renderExtendedCapabilities = ({
		capabilities,
		parentType
	}: renderExtendedCapabilitiesProps): React.JSX.Element => {
		return (
			<>
				{_.map(
					Object.entries(capabilities),
					([capabilityName, capabilityValue], index) => {
						return (
							capabilityValue && (
								<Text
									kind={`PARAGRAPH`}
									className={
										parentType === `subCat`
											? `${styles.subAccordionExtendedCapability}`
											: `${styles.accordionExtendedCapability}`
									}
									testId={`${capabilityName}-capability-title`}
									key={`${capabilityName}-${index}`}
								>
									{capabilityName}
								</Text>
							)
						);
					}
				)}
			</>
		);
	};

	return (
		<>
			{shouldDisplayCategory(category) && (
				<div className={`${styles.featureListItem}`}>
					<Accordion
						testId={`${category.categoryName}-accordion-features-testid`}
						classNameForContainer={`${styles.accordion}`}
						classNameForHeading={`${styles.commonAccordionHeadingContainer}`}
						sections={[
							{
								heading: (
									<Text
										kind={`PARAGRAPH_STRONG`}
										className={`${styles.commonAccordionHeadingText}`}
										testId={`${category.categoryName}-category-title`}
									>
										{category.categoryName}
									</Text>
								),
								screenReaderLabel: category.categoryName,
								body: hasSubCategory ? (
									<>
										<div className={styles.emptyDiv} />
										{_.map(
											(
												category as FeaturesAndCapabilitiesResponsePayloadServiceCategorySub
											).subCategory || [],
											(subCat, index) => {
												return (
													<div
														key={`${category.categoryName}-${index}`}
													>
														{shouldDisplaySubCategory(
															subCat
														) && (
															<Accordion
																testId={`${removeSpecialCharacters(
																	subCat.subCategoryName
																)}-accordion-features-testid`}
																classNameForHeading={`${styles.commonAccordionHeadingContainer}`}
																classNameForContainer={`${styles.subAccordion}`}
																sections={[
																	{
																		heading:
																			(
																				<Text
																					kind={`PARAGRAPH_STRONG`}
																					className={`${styles.commonAccordionHeadingText}`}
																					testId={`${subCat.subCategoryName}-sub-category-title`}
																				>
																					{
																						subCat.subCategoryName
																					}
																				</Text>
																			),
																		screenReaderLabel:
																			subCat.subCategoryName,
																		body: subCat.extendedCapability && (
																			<>
																				<div
																					className={
																						styles.emptyDiv
																					}
																				/>
																				{renderExtendedCapabilities(
																					{
																						capabilities:
																							subCat.extendedCapability,
																						parentType: `subCat`
																					}
																				)}
																				<div
																					className={
																						styles.emptyDiv
																					}
																				/>
																			</>
																		),
																		showChevron:
																			true
																	}
																]}
															/>
														)}
													</div>
												);
											}
										)}
									</>
								) : (
									<>
										<div className={styles.emptyDiv} />
										{renderExtendedCapabilities({
											capabilities:
												(
													category as FeaturesAndCapabilitiesResponsePayloadServiceCategoryExt
												).extendedCapability || {},
											parentType: `cat`
										})}
									</>
								),
								showChevron: true
							}
						]}
					/>
				</div>
			)}
		</>
	);
}
